import React, { useEffect } from "react";
import CustomInput from "../../../common/components/CustomInput/CustomInput.jsx";
import FormWarning from "./FormWarning";

const EasyCanadaPostalCode = props => {
  useEffect(() => {
    props.connectForm.setPropMounted(propName, true);
    return () => {
      props.connectForm.setPropMounted(propName, false);
    };
  }, []);

  const propName = props.propName;

  function transformPostalCode(value) {
    let returnValue = value;
    let autoCompletedValue = "";

    returnValue = returnValue.toUpperCase();

    if (/^[A-Z]\d[A-Z][A-Z0-9]$/.test(returnValue)) {
      returnValue = returnValue.slice(0, 3) + " " + returnValue.slice(3);
    }

    if (returnValue.length === 6 && returnValue[3] !== " ") {
      for (var i = 0; i < 6; i++) {
        if (i === 3) {
          autoCompletedValue = autoCompletedValue + " ";
        }
        autoCompletedValue = autoCompletedValue + returnValue[i];
      }
      returnValue = autoCompletedValue;
    }

    return returnValue;
  }

  return (
    <div>
      <CustomInput
        success={props.connectForm.getState(propName) === "Success"}
        error={props.connectForm.getState(propName) === "Error"}
        labelText={
          <span>
            {props.connectForm.getLabel(propName) + " "}
            {props.connectForm.isRequired(propName) ? <span>*</span> : ""}
          </span>
        }
        id={propName}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event =>
            props.connectForm.change(
              transformPostalCode(event.target.value),
              propName
            ),
          value: props.connectForm.getValue(propName),
          autoComplete: "off"
        }}
      />
      <FormWarning
        isValid={props.propName}
        isError={props.connectForm.getState(propName)}
        errorMessage={props.connectForm.getErrorMessage(propName)}
      />
    </div>
  );
};

export default EasyCanadaPostalCode;
